export default __webpack_public_path__ + "static/media/tagAndTrack.4defc7a6.png";